import React, { FC } from "react";
import { connect, Dispatch } from "react-redux";
import { IStore } from "reducers";
import { MediaDialog } from "./dialog";
import { format } from "lib/globalize-util";
import { setAccessControlError } from "actions/access-control-actions";
import { makeStyles } from "@material-ui/core";
import { IAccessControlState } from "reducers/access-control-reducers";
import { DATATEST } from "constants/integration";

interface IStateProps {
    error: IAccessControlState["error"];
}

interface IDispatchProps {
    onClose: () => void;
}

const AccessControlErrorModalComponent: FC<IStateProps & IDispatchProps> = (props) => {
    const { error, onClose } = props;
    const classes = useStyles();
    return (
        <MediaDialog open={!!error} title={format("Access revoked")} onClose={onClose}>
            <span className={classes.modalBody} data-test={DATATEST.ACCESS_CONTROL_ERROR_MODAL_BODY}>
                {format("The portal you are trying to access has removed access to the portal at this time.")}
            </span>
        </MediaDialog>
    );
};

const useStyles = makeStyles({
    modalBody: {
        fontSize: 16,
    },
});

const mapStateToProps = (store: IStore): IStateProps => ({
    error: store.accessControl.error,
});

const mapDispatchToProps = (dispatch: Dispatch<IStore>) => ({
    onClose: () => dispatch(setAccessControlError(null)),
});

export const AccessControlErrorModal = connect<IStateProps, IDispatchProps, {}>(
    mapStateToProps,
    mapDispatchToProps
)(AccessControlErrorModalComponent);
